:host {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  @include cms-base-font-100;
}

@include price-font-sizes();

@include energy-rank-color(8);

/* Button */
button.energy-label-element {
  display: inline-flex;
  padding-left: 3px;
  /* Disable button default-padding */


  &.energy-version-v2 {
    .svg-eek-template {
      height: 3.1875rem;
    }

    &.multi .svg-eek-template {
      height: 3rem;
    }
  }

}

button {
  display: inline-block;
  text-decoration: none;
  white-space: nowrap;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
}

.svg-eek-template {
  width: auto;
  vertical-align: middle;
}

.energy-label-element {
  
  margin: 0 0 var(--cms-spacing-075);
  max-width: 100%;

  /* V1 */
  flex-wrap: nowrap;
  gap: 0.5rem;
  align-items: center;
  display: flex;

  &.multi {
    margin-bottom: 0;
  }
}

/* Datasheet & additional label (name) */
.name-wrapper {  
  line-height: var(--cms-line-height-125);
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.datasheet-wrapper {
  display: flex;
  font-family: var(--cms-brandfont2);
  font-size: var(--cms-font-size-100);
  flex-direction: column;
  text-align: left;
  align-items: start;
  justify-content: center;
  color: var(--cms-semanticColors-base-strong-text);
  --cms-text-color: var(--cms-semanticColors-base-strong-text);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.datasheet-link-wrapper {
  display: flex;
  align-items: center;
  max-width: 100%;
}

.datasheet-link {
  color: var(--cms-semanticColors-base-strong-text);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.datasheet-link:active {
  text-decoration: none;
  color: var(--cms-semanticColors-base-strong-active-text);
}

.datasheet-link:hover {
  text-decoration: none;
}

/* image */
img {
  width: auto;
  vertical-align: middle;
}

/* Sizes */
:host(.lg) {
  .energy-version-v1 .label {
    font-size: 2.4375rem;
    padding: 0.7rem 2.6rem 0.7rem 1.2rem;
    clip-path: polygon(0% 0%, calc(100% - 30.5px) 0%, 100% 50%, calc(100% - 30.5px) 100%, 0% 100%);
  }

  .energy-version-v1 img {
    height: 3.625rem;
  }

  .energy-version-v2 .svg-eek-template {    
    height: 3.938rem;
  }
}


:host(.md) {
  .energy-version-v1 .label {
    font-size: 2.0625rem;
    padding: 0.55rem 2.1rem 0.55rem 1rem;
    clip-path: polygon(0% 0%, calc(100% - 24px) 0%, 100% 50%, calc(100% - 24px) 100%, 0% 100%);
  }

  .energy-version-v1 img {
    height: 3.125rem;
  }

  .energy-version-v2 .svg-eek-template {    
    height: 3.188rem;
  }
}

:host(.sm) {
  .energy-version-v1 .label {
    font-size: 1.625rem;
    padding: 0.45rem 1.7rem 0.4rem 0.7rem;
    clip-path: polygon(0% 0%, calc(100% - 20px) 0%, 100% 50%, calc(100% - 20px) 100%, 0% 100%);
  }

  .energy-version-v1 img {
    height: 2.375rem;
  }

  .energy-version-v2 .svg-eek-template {    
    height: 2.563rem;
  }
}

:host(.xs) {
  .energy-version-v1 .label {
    font-size: 1.1875rem;
    padding: 0.35rem 1.2rem 0.35rem 0.5rem;
    clip-path: polygon(0% 0%, calc(100% - 16px) 0%, 100% 50%, calc(100% - 16px) 100%, 0% 100%);
  }

  .energy-version-v1 img {
    height: 2rem;
  }

  .energy-version-v2 .svg-eek-template {    
    height: 1.938rem;
  }
}